import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export interface IHoursModalProps {
  name: string;
  weekdayDescriptions: string[];
  onClose: () => void;
}

export const HoursModal: React.FunctionComponent<IHoursModalProps> = ({
  name,
  weekdayDescriptions,
  onClose,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`internalToolsHomePage.gbp_places_query.detail.table.${key}`);

  return (
    <div className="modal-default gbp-places-query-hours-modal">
      <div className="modal-mains">
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
        ></button>
        <div className="top-title">{t("hours")}</div>
        <p className="gbp-places-query-hours-modal-name">{name}</p>
        <div className="gbp-places-query-hours-modal-list">
          <ul>
            {weekdayDescriptions.map((line, index) => (
              <li key={index}>{line}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HoursModal;
